<div class="insights-container">
  <div *ngIf="compareToFleet; else elseBlock">
    
    <div class="row ms-2 me-2 mt-1 mb-1 ps-0 pe-0">
      <div class="col-md-6 ps-0 pe-0">
        <app-temp-comfort-zone-chart-ef-chart [selectedVehicles]="selectedVehicles" *ngIf="fleetId.length > 0" [fleetId]="fleetId" [companyData]="companyData" [isMetric]="isMetric"></app-temp-comfort-zone-chart-ef-chart>
      </div>
      <div class="col-md-6 ps-0 pe-0">
        <!-- <app-time-spent-extreme-temp-ef-chart [selectedVehicles]="selectedVehicles" [vehiclesTempInsights]="vehiclesTempInsights" 
        *ngIf="fleetId.length > 0" [fleetId]="fleetId"></app-time-spent-extreme-temp-ef-chart> -->
      </div>
    </div>
    
    <hr class="ms-2 me-2 mt-1 mb-1 ps-0 pe-0">
    
    <div class="row ms-2 me-2 mt-1 mb-1 ps-0 pe-0">
      <div class="col-md-6 ps-0 pe-0">
        <!-- <app-time-spent-extreme-temp-low-ef-chart [selectedVehicles]="selectedVehicles" [vehiclesTempInsights]="vehiclesTempInsights" 
          [timeSpentExtremeTemperatureDatapoints]="timeSpentExtremeTemperatureDatapoints" *ngIf="fleetId.length > 0" [fleetId]="fleetId"></app-time-spent-extreme-temp-low-ef-chart> -->
      </div>
      <div class="col-md-6 ps-0 pe-0">
        <!-- <app-time-spent-extreme-temp-high-ef-chart [selectedVehicles]="selectedVehicles" [vehiclesTempInsights]="vehiclesTempInsights"  
          [timeSpentExtremeTemperatureDatapoints]="timeSpentExtremeTemperatureDatapoints" *ngIf="fleetId.length > 0" [fleetId]="fleetId"></app-time-spent-extreme-temp-high-ef-chart> -->
      </div>
    </div>
    
  </div>

  <ng-template #elseBlock>
    
    <div class="row ms-0 me-0">
      <div class="col-12">
        <table class="m-table" *rbTable="loader; fixedHeaderWidth: false; columns: 4" [rbSort]="{id: '', direction: ''}" (rbSortChange)="currentVehicleData = sortData($event, currentVehicleData)">
          <thead>
            <tr>
              <th rb-sort-header="vehicleName" [disableSortClear]="true">Vehicle Name</th>
              <th rb-sort-header="timeExtremeLowTemp" [disableSortClear]="true">
                <span rbTooltip="Total duration for which the battery pack was operated at temperatures below 0 °C, which can lead negative effect on range." [noFix]="false">
                  Time Spent in Low Temperature
                </span>
              </th>
              <th rb-sort-header="timeExtremeHighTemp" [disableSortClear]="true">
                <span rbTooltip="Total duration for which the battery pack was operated at temperatures above 40 °C, which cause increased risk of battery degradation." [noFix]="false">
                  Time Spent in High Temperature
                </span>
              </th>
              <th rb-sort-header="timeChargingExtremeTemp" [disableSortClear]="true">
                <span rbTooltip="Total duration for which the battery pack was charged at temperatures above 40 °C, which can lead negative impact on battery lifetime and range." [noFix]="false">
                  Time Spent Charging in Extreme Temperature
                </span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let vehicle of currentVehicleData">
              <td>
                {{ vehicle.vehicleName !== null && vehicle.vehicleName !== undefined && vehicle.vehicleName !== '' ? vehicle.vehicleName : 'N/A' }}
              </td>
              <td>
                {{ vehicle.timeExtremeLowTemp !== null && vehicle.timeExtremeLowTemp !== undefined ? (vehicle.timeExtremeLowTemp | hourToMinute) : 'N/A' }}
              </td>
              <td>
                {{ vehicle.timeExtremeHighTemp !== null && vehicle.timeExtremeHighTemp !== undefined ? (vehicle.timeExtremeHighTemp | hourToMinute) : 'N/A' }}
              </td>
              <td>
                {{ vehicle.timeChargingExtremeTemp !== null && vehicle.timeChargingExtremeTemp !== undefined ? (vehicle.timeChargingExtremeTemp | hourToMinute) : 'N/A' }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    
    <div class="row ms-2 me-2 mt-1 mb-1 ps-0 pe-0">
      <div class="col-md-6 ps-0 pe-0">
        <app-temperature-comfort-zone-chart [selectedVehicles]="selectedVehicles" [companyData]="companyData" [isMetric]="isMetric"></app-temperature-comfort-zone-chart>
      </div>
    </div>
    
  </ng-template>
</div>